export default __webpack_public_path__ + "static/Alex-6f93059daed19560af17759edcfadb72.png";